import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceExecutionObjectiveApproveProps {
  objectiveId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceExecutionObjectiveApprove = ({
  objectiveId,
  options,
}: UseMaintenanceExecutionObjectiveApproveProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceExecutionObjectiveApprove'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/execution_objectives/${objectiveId}`, {
        execution_objective: {
          last_review_attributes: {
            state: 'approved',
          },
        },
      });
    },
    ...options
  });
}
